import type { FC } from "react"
import { Link, Navigate, Outlet, useLocation, useNavigate } from "react-router"
import { LoadingSpinner } from "@/components/LoadingSpinner"
import { Logo } from "@/components/Logo"
import { TenantPublicMenu } from "@/components/tenant/tenant-public-menu"
import { auth } from "@/lib/firebase"
import { useTenantOnboardingStatus } from "@/lib/use-tenant-onboarding-status"
import { useCurrentUser } from "@/lib/useCurrentUser"

export const LoggedOutGateLayout: FC = () => {
  const currentUser = useCurrentUser()
  const location = useLocation()
  const navigate = useNavigate()
  const { isResolving, needsOnboarding } = useTenantOnboardingStatus()
  const isEmailNotVerifiedRoute = location.pathname === "/signup/email-not-verified"
  const isSignupInfoRoute = location.pathname === "/signup/info"
  const shouldSignOutBeforeNavigation = Boolean(currentUser && !currentUser.emailVerified)

  const handleNavigateToSignup = async () => {
    if (shouldSignOutBeforeNavigation) {
      await auth.signOut()
    }

    navigate("/signup")
  }

  if (!currentUser?.emailVerified) {
    if (currentUser && !isEmailNotVerifiedRoute) {
      return <Navigate to="/signup/email-not-verified" replace state={{ from: location }} />
    }
  }

  if (currentUser?.emailVerified) {
    if (isResolving) {
      return (
        <main className="h-screen flex items-center justify-center">
          <LoadingSpinner />
        </main>
      )
    }

    if (needsOnboarding) {
      if (!isSignupInfoRoute) {
        return <Navigate to="/signup/info" replace state={{ from: location }} />
      }
    } else {
      return <Navigate to="/dashboard" replace state={{ from: location }} />
    }
  }

  return (
    <div className="bg-bg-white">
      <header className="border-b border-border bg-bg-white">
        <div className="mx-auto flex h-12 w-full items-center justify-between pl-6 pr-2">
          <Link to="/login" className="min-w-0">
            <Logo />
          </Link>
          <div className="flex items-center">
            <button
              type="button"
              className="inline-flex h-7 items-center px-2 text-[13px] font-semibold leading-[1.35] text-foreground"
              onClick={() => void handleNavigateToSignup()}
            >
              <span>新規登録</span>
            </button>
            <TenantPublicMenu shouldSignOutBeforeNavigation={shouldSignOutBeforeNavigation} />
          </div>
        </div>
      </header>

      <main className="pb-16 md:pt-8">
        <Outlet />
      </main>
    </div>
  )
}
